import { FC } from 'react';

interface IStatusButton {
  status?: string;
}

const StatusButton: FC<IStatusButton> = ({ status }: IStatusButton) => {
  return (
    <div id="statusButton">
      {status === 'Activo' ? (
        <div className="activeButton">
          <div className="text">Activo</div>
          <div className="circle" />
        </div>
      ) : status === 'Inactivo' ? (
        <div className="inactiveButton">
          <div className="circle" />
          <div className="text">Inactivo</div>
        </div>
      ) : (
        <div className="outOfStockButton">
          <div className="circle" />
          <div className="textSwitch">Sin stock</div>
        </div>
      )}
    </div>
  );
};
export default StatusButton;
